import React from 'react';
import Evals from '../EvaluationComponents/Evals';

/**
 * TalentEvals Component
 * Wrapper for the shared Evals component with talent context
 */
const TalentEvals = ({ talent, ...props }) => {
  // Log the talent object for debugging
  console.log('TalentEvals - talent prop:', talent);
  
  return <Evals entity={talent} contextType="talent" {...props} />;
};

export default TalentEvals;
